import { getServerURL } from "../shared/sharedFunctions";
import riskService from "./riskService";
import userService from "./userService";

const DarkWebService = () => {
	const pub = {};
	
	let breaches = [];
	pub.Breaches = () => {
		return breaches;
	}
	
	pub.BreachesForDomain = (domain, fromDate = null, toDate = null) => {
		if (!domain) return [];
		
		return breaches.filter((breach) => {
			return (
				breach.address === domain.address &&
				(fromDate === null || breach.breach_date >= fromDate) &&
				(toDate === null || breach.breach_date <= toDate)
			);
		});
	};
	
	pub.BreachesForDates = (fromDate = null, toDate = null) => {
		let returnBreaches = breaches.filter((breach) => {
			return (
				(fromDate === null || breach.breach_date >= fromDate) &&
				(toDate === null || breach.breach_date <= toDate)
			);
		});
		
		return returnBreaches;
	};
	
	pub.all = async (companyId) => {
		const req = {
			method: "GET",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
		};
		
		let response = await fetch(`${getServerURL()}/api/breach/all/${companyId}`, req);
		if (response.status !== 200) {
			throw new Error(response.staus);
		}
		
		const data = await response.json();
		breaches = data.breaches;
		riskService.syntheticIds = data.syntheticIds;
		
		for (let i in breaches) {
			breaches[i].breach_date = new Date(breaches[i].breach_date);
		}
	};
	
	pub.getMinBreachDate = (domain = null) => {
		let minDate = new Date();
		
		const breaches = (domain)? pub.BreachesForDomain(domain) : pub.Breaches();
		for (let i = 0; i < breaches.length; i++) {
			if (breaches[i].breach_date < minDate) {
				minDate = breaches[i].breach_date;
			}
		}
		
		return minDate;
	};
	
	pub.getMaxBreachDate = (domain) => {
		let maxDate = new Date();
		
		const breaches = (domain)? pub.BreachesForDomain(domain) : pub.Breaches();
		for (let i = 0; i < breaches.length; i++) {
			if (maxDate === null || breaches[i].breach_date >= maxDate) {
				maxDate = breaches[i].breach_date;
			}
		}
		
		return (maxDate === null)? new Date() : maxDate;
	};
	
	pub.getTotals = (fromDate, toDate) => {
		const breachesCounted = {};
		const emailAddressesCounted = {};
		const dataTypesCounted = {};
		
		const totals = {
			compromisedAccounts: 0,
			emailAddresses: 0,
			passwords: 0,
			breaches: 0,
			dataItems: 0,
			dataTypes: 0
		};
		
		const breaches = pub.BreachesForDates(fromDate, toDate);
		for (let i = 0; i < breaches.length; i++) {			
			totals.compromisedAccounts += 1;
			
			if (!emailAddressesCounted.hasOwnProperty(breaches[i].email)) {
				totals.emailAddresses += 1;
				emailAddressesCounted[breaches[i].email] = true;
			}
			
			if (breaches[i].compromised_data.includes("Passwords")) {
				totals.passwords += 1;
			}
			
			if (!breachesCounted.hasOwnProperty(breaches[i].name + breaches[i].breach_date.toString())) {
				totals.breaches += 1;
				breachesCounted[breaches[i].name + breaches[i].breach_date.toString()] = true
			}
			
			const dataTypes = breaches[i].compromised_data.split(",");
			
			totals.dataItems += dataTypes.length;
			
			for (let j = 0; j < dataTypes.length; j++) {
				if (!dataTypesCounted.hasOwnProperty(dataTypes[j])) {
					totals.dataTypes += 1;
					dataTypesCounted[dataTypes[j]] = true;
				}
			}
		}
		
		return totals;
	};
	
	return pub;
};

export default DarkWebService();